/*
 * @Author: your name
 * @Date: 2021-03-31 15:43:39
 * @LastEditTime: 2021-03-31 15:44:30
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/lib/ui/components/form/form-other-table-field/index.js
 */
import FormOtherTableField from './form-other-table-field.vue'

FormOtherTableField.install = (vue) => {
  vue.component(FormOtherTableField.name,FormOtherTableField)
}

export default FormOtherTableField